import { Injectable, inject } from '@angular/core';
import { BaseModel } from '../models/basemodel';
import { AbstractDataService } from './abstractdata.service';
import { DataTableModuleConfiguration } from './datatable-module.config';

@Injectable({ providedIn: 'root' })
export class B2bDataService<T extends BaseModel> extends AbstractDataService<T> {
  constructor() {
    const configuration = inject(DataTableModuleConfiguration);
    if (!configuration.apiUrls.b2b) {
      throw new Error('B2B API URL is not configured');
    }
    super(`${configuration.apiUrls.b2b}/api`);
  }
}
